import * as s from '~js/utils/selectors';
import * as c from '~js/utils/classes';


export class SwatchesContainer {
  constructor(container) {
    this.container = container;
    this.swatchesContainers = this.container.querySelectorAll(s.selectors$X.swatchesContainer);

    this.swatchesContainers.forEach((swatchesContainer) => {
      this.checkSwatchesHeightOnResize = () => this.checkSwatchesHeight(swatchesContainer);
      this.checkSwatchesHeight(swatchesContainer);
      document.addEventListener('theme:resize:width', this.checkSwatchesHeightOnResize);
    });
  }

  checkSwatchesHeight(swatchesContainer) {
    const label = swatchesContainer.querySelector(s.selectors$X.swatchesLabel);
    const swatch = swatchesContainer.querySelector(s.selectors$X.swatchesButton);
    const containerPaddingTop = parseInt(window.getComputedStyle(swatchesContainer).getPropertyValue('padding-top'));
    const labelMargin = parseInt(window.getComputedStyle(label).getPropertyValue('margin-bottom'));
    const swatchMargin = parseInt(window.getComputedStyle(swatch).getPropertyValue('margin-bottom'));
    const selectorWrapper = swatchesContainer.closest(s.selectors$X.selectorWrapper);
    selectorWrapper.classList.remove(c.classes$N.selectorLarge);

    if (
      swatchesContainer.offsetHeight - containerPaddingTop >
      label.offsetHeight + labelMargin + swatch.offsetHeight * 2 + swatchMargin * 2
    ) {
      swatchesContainer.style.setProperty('--swatches-max-height', `${swatchesContainer.offsetHeight}px`);
      selectorWrapper.classList.add(c.classes$N.selectorLarge);
    }
  }

  onUnload() {
    this.swatchesContainers.forEach((swatchesContainer) => {
      document.removeEventListener('theme:resize:width', this.checkSwatchesHeightOnResize);
    });
  }
}